import { render, staticRenderFns } from "./LocaleSelect.vue?vue&type=template&id=687ba98f&scoped=true&"
import script from "./LocaleSelect.vue?vue&type=script&lang=js&"
export * from "./LocaleSelect.vue?vue&type=script&lang=js&"
import style0 from "./LocaleSelect.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./LocaleSelect.vue?vue&type=style&index=1&id=687ba98f&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "687ba98f",
  null
  
)

export default component.exports